<div class="editor">
  <ckeditor
    [config]="config"
    [editor]="ClassicEditor"
    [formControl]="innerControl"
  />
  <div id="editor-footer" class="editor-footer">
    <span>
      {{ "publicationTemplate.create.dynamicTags.title" | translate }}
    </span>
  </div>
</div>
